

export default function VersionAvatarConfig(row) {

    // const getFolderAvatarConfig = (row) => {
        const exception = row.exception === "Exception";
        const versionStatus = row.versionStatus || row.versionStatus || "";
        const versionPurpose = row.versionPurpose || row.versionPurpose || "";

        let avatarLetter = " ";
        let avatarBg = "error.main";
        let avatarTooltip = "No status";

        let badgeLetter = "s";
        let badgeBg = "grey.800";
        let badgeTooltip = "No Frequency Defined";



 if (versionStatus === "2039") {
    avatarLetter = "a";
    avatarBg = "primary.main";
    avatarTooltip = "Approved";

 } else if (versionStatus === "3409") {
     avatarLetter = "a";
     avatarBg = "grey.400";
     avatarTooltip = "Archived";

 } else if (versionStatus === "3208") {
     avatarLetter = "b";
     avatarBg = "success.main";
     avatarTooltip = "Blocked";

 } else if (versionStatus === "2043") {
     avatarLetter = "d";
     avatarBg = "warning.main";
     avatarTooltip = "Deferred";


 } else if (versionStatus === "2339") {
            avatarLetter = "g";
            avatarBg = "success.main";
            avatarTooltip = "Generated";


 } else if (versionStatus === "3709") {
     avatarLetter = "h";
     avatarBg = "grey.400";
     avatarTooltip = "History";

        } else if (versionStatus === "3242") {
            avatarLetter = "i";
            avatarBg = "grey.500";
            avatarTooltip = "Issued";


 } else if (versionStatus === "3410") {
     avatarLetter = "o";
     avatarBg = "warning.main";
     avatarTooltip = "Omitted";

        } else if (versionStatus === "2351") {
            avatarLetter = "p";
            avatarBg = "warning.main";
            avatarTooltip = "Paid";



        } else if (versionStatus === "3706") {
            avatarLetter = "t";
            // avatarBg = "deepPurple.500";
            avatarBg = "#673ab7";
            avatarTooltip = "Test";
        }






        if (versionPurpose === "3407") {
            badgeLetter = "r";
            badgeBg = "info.main";
            badgeTooltip = "Reporting";
        } else if (versionPurpose === "3408") {
            badgeLetter = "s";
            badgeBg = "grey.600";
            badgeTooltip = "Supporting";
        }
        if (exception) {
            avatarLetter = "!";
            avatarBg = "error.dark";
            avatarTooltip = "Exception folder";
        }

        return {
            avatarLetter,
            avatarBg,
            avatarTooltip,
            badgeLetter,
            badgeBg,
            badgeTooltip,
        };
    // };
};
